OrderPrintDocumentsCtrl.$inject = ["orderPrintDocumentsService", "$httpParamSerializer"];
/* @ngInject */

function OrderPrintDocumentsCtrl(orderPrintDocumentsService, $httpParamSerializer) {
  var ctrl = this;
  ctrl.$onInit = () => {
    if (ctrl.disabled === undefined) {
      ctrl.disabled = false;
    }
    if (ctrl.onlyWhenPaying === undefined) {
      ctrl.onlyWhenPaying = false;
    }
    if (ctrl.orderIsComplete === undefined) {
      ctrl.orderIsComplete = false;
    }
    (ctrl.onlyWhenPaying || !ctrl.orderIsComplete ? orderPrintDocumentsService.getLegalDocumentWhenPaying(ctrl.orderNumber) : orderPrintDocumentsService.getLegalDocumentAll(ctrl.orderNumber)).then(data => {
      ctrl.orderId = data.OrderId;
      ctrl.documents = data.Documents;
    });
  };
  ctrl.print = templateId => {
    var params = {
      orderId: ctrl.orderId,
      templatesDocx: templateId
    };
    var url = 'printDocument/generateTemplates';
    window.open(url + '?' + $httpParamSerializer(params));
  };
}
export default OrderPrintDocumentsCtrl;